import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listTeamMembers, deleteTeamMember } from "../../../api/cms";

export default function AdminTeamMembers() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = () => {
    setLoading(true);
    listTeamMembers()
      .then(setTeamMembers)
      .catch(() => setError("Failed to load team members"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this team member?")) return;
    await deleteTeamMember(id);
    load();
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Team members</h1>
        <Link to="/admin/team-members/new" className="bg-bahyellow rounded px-4 py-2 text-sm font-semibold hover:opacity-90">
          + Add team member
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-4 py-3 font-semibold">Photo</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Position</th>
              <th className="px-4 py-3 font-semibold">Teams</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {teamMembers.map((m) => (
              <tr key={m.id}>
                <td className="px-4 py-3">
                  {m.image && <img src={m.image} alt={m.name} className="w-10 h-10 rounded-full object-cover" />}
                </td>
                <td className="px-4 py-3 font-medium">{m.name}</td>
                <td className="px-4 py-3 text-gray-600 max-w-xs truncate">{m.position}</td>
                <td className="px-4 py-3 text-gray-500 text-xs">{(m.teams || []).join(", ")}</td>
                <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
                  <Link to={`/admin/team-members/${m.id}/edit`} className="text-blue-600 hover:underline">Edit</Link>
                  <button onClick={() => handleDelete(m.id)} className="text-red-500 hover:underline">Delete</button>
                </td>
              </tr>
            ))}
            {teamMembers.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400">No team members yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
